var React = require('react');

function IconMultiChart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M26 7.277L24.308 5.6l-3.42 3.807A12.981 12.981 0 0 0 11.132 5 13.84 13.84 0 0 0 2 8.558l1.7 1.684a11.34 11.34 0 0 1 7.428-2.87 10.594 10.594 0 0 1 8.124 3.843L15.8 15.058 11 10.314l-9 8.907L3.8 21l7.2-7.128 4.8 4.744 4.86-5.4a14.435 14.435 0 0 1 1.728 5.4H24.8a16.643 16.643 0 0 0-2.448-7.282z","transform":"translate(-2 -5)"}));
}

IconMultiChart.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = IconMultiChart;

IconMultiChart.default = IconMultiChart;
